// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundFilledSvg from "@fishx/icons-svg/es/asn/FundFilled";
import FishxIcon from '../components/FishxIcon';

var FundFilled = function FundFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundFilledSvg
  }));
};

FundFilled.displayName = 'FundFilled';
export default React.forwardRef(FundFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FundFilled.js
// module id = 2841
// module chunks = 0